import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, api } from '../../lib/api';

const fetchChangelogStatus = async page => {
  return get('/api/client_admin/changelog', { page });
};

const postMarkAsRead = async page => {
  return api.post('/api/client_admin/changelog/mark_as_read', { page });
};

export const useChangelog = page => {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey: ['changelog', page],
    queryFn: () => fetchChangelogStatus(page),
    enabled: !!page,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });

  const { mutate: markAsRead } = useMutation({
    mutationFn: () => postMarkAsRead(page),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['changelog', page] });
    },
  });

  return {
    hasUnreadReleases: data?.data?.has_unread_releases ?? false,
    latestTitle: data?.data?.latest_title ?? null,
    latestBody: data?.data?.latest_body ?? null,
    latestCtaUrl: data?.data?.latest_cta_url ?? null,
    latestCtaLabel: data?.data?.latest_cta_label ?? "See what's new",
    changelogUrl: data?.data?.changelog_url ?? '/client_admin/changelog',
    markAsRead,
    isLoading,
    error,
  };
};
